export class Webforms {
  constructor() {
    this.init();
  }

  init() {
    var context = document.querySelector(
      '.site-wrap.interior-wrap #block-rush-theme-mainpagecontent'
    );
    if (context) {
      nakedFormSelect('.webform-submission-form select', {
        context: {
          value: context,
        },
      });
    }

    $(context).on('click', '.print-button', function (e) {
      e.preventDefault();
      window.print();
    });
  }
}
